import * as z from "zod";
import { decimal } from "../index";

// What the inputs of the sales domain share.

/** Why a person does something to an order: it goes to its history, and is shown to who reads it. */
export const reason = z.string().trim().min(1).max(2000);

/**
 * An amount in the currency of an order, zero or more, within what `numeric(18, 4)` keeps: a longer one would fail in
 * the DB, more decimals would be rounded without a word.
 */
export const orderAmount = decimal.regex(/^\d{1,14}(\.\d{1,4})?$/, "at most 14 digits and 4 decimals, not negative");
